<div class="pos-relative w-p-100">
  <div class="keno-grid-container">
    <particle-dynamic-grid-kendo-content
      [items$]="recipients$"
      [fieldDefinitions$]="fieldDefinitions$"
      [selectableSettings]="selectableSettings"
      [selectBy]="selectBy"
      [selectedKeys]="selectedKeys"
      [pageable]="false"
      [rowCallback]="rowCallback"
      (selectionChanged)="onFieldGridSelectionChanged($event)"
      (valueChanged)="valueChanged($event)"
      (selectedKeyChange)="onSelectedKeychange($event)">
    </particle-dynamic-grid-kendo-content>
  </div>
</div>
